import s from "./thirdSlide.module.css";
import {useThirdSlide} from "./useThirdSlide";
import {SSMThirdSlideAttendancesPreview, SSMThirdSlideCheckMark, SSMThirdSlideVoucherPreview} from "../../../../assets";
import ProgressBar from "../ProgressBar";
import {Fragment} from "preact";

const ThirdSlide = (props) => {
    // Destructured props
    const {
        selfServiceAttendanceModalData,
        currentSlide,
        handleCurrentSlide,
        TOTAL_SLIDES,
        stage,
        setStage
    } = props;

    // Component logic data
    const componentProps = useThirdSlide({});

    // Destructured component logic data
    const {} = componentProps;

    // Check mark icon
    const checkMark =
        stage !== 2 ? null : (
            <img
                src={SSMThirdSlideCheckMark}
                alt="Check mark"
                className={`${s.checkMark}`}
            />
        );

    // Voucher preview image
    const voucherPreview =
        stage !== 3 ? null : (
            <img
                src={SSMThirdSlideVoucherPreview}
                alt="Voucher preview"
                className={`${s.voucherPreview}`}
            />
        );

    // Second paragraph block
    const secondParagraph =
        stage < 3 ? null : (
            <p className={`${s.paragraph} ${s.showSecondParagraph}`}>
                {selfServiceAttendanceModalData?.stepTwoTextTwo || (
                    <Fragment>
                        Quando finalizar a compra,&nbsp;
                        <span className={`text-sabin-red-default`}>
                            um voucher
                        </span>
                        &nbsp;será emitido automaticamente.
                    </Fragment>
                )}
            </p>
        );

    return (
        <div className={`w-full h-full relative ${s.root}`}>
            {/* Backdrop */}
            <div className={`w-full h-full absolute top-0 left-0 z-10 pointer-events-none transition-all duration-300 bg-black ${currentSlide > 2 ? "opacity-50" : "opacity-0"}`} />

            <div className={`absolute w-full h-full left-0 top-0 container-fluid`}>
                <div className={`sabin-container h-full flex flex-col-reverse lg:flex-row items-center justify-center lg:justify-between gap-x-4 gap-y-8 lg:gap-y-12 !pb-24 lg:!pb-0`}>
                    <div className={`flex flex-col gap-y-6 ${s.textBlock}`}>
                        <h1 className={`${s.heading}`}>
                            {selfServiceAttendanceModalData?.stepTwoTitle || `Veja como é fácil:`}
                        </h1>
                        <div className={`relative z-0`}>
                            <p className={`${s.paragraph} ${stage > 1 ? s.hideFirstParagraph : ""}`}>
                                {selfServiceAttendanceModalData?.stepTwoTextOne || (
                                    <Fragment>
                                        Ao comprar na loja virtual, selecione a opção&nbsp;
                                        <span className={`text-sabin-red-default`}>
                                            Unidade Digital Sabin
                                        </span>
                                        &nbsp;no checkout.
                                    </Fragment>
                                )}
                            </p>
                            {secondParagraph}
                        </div>
                    </div>
                    <div className={`${s.imagesContainer}`}>
                        <img
                            src={SSMThirdSlideAttendancesPreview}
                            alt="Attendances preview"
                            className={`shadow-xl rounded-[45px] max-h-[345px] md:max-h-[502px] lg:max-h-full select-none ${stage > 1 ? s.hideAttendances : ""}`}
                        />
                        {checkMark}
                        {voucherPreview}
                    </div>
                </div>
            </div>
            <div className={`container-fluid w-full h-full`}>
                <div className={`sabin-container h-full pointer-events-none relative ${currentSlide > 2 && "hidden"}`}>
                    <ProgressBar
                        currentSlide={currentSlide}
                        handleCurrentSlide={handleCurrentSlide}
                        centered={true}
                        TOTAL_SLIDES={TOTAL_SLIDES}
                    />
                </div>
            </div>
        </div>
    )
}

export default ThirdSlide;
